<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    @import "../common/style/variables";
    .navbar {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 1000;
        padding-left: calc(100vw - 100%);
        box-shadow: 0 2px 4px 0 #DDDDDD;
        .container {
            position: relative;
            width: 100%;
            min-width: 1200px;
            height: 100px * @scaleRate;
            .logo {
                cursor: pointer;
                position: absolute;
                bottom: 4.25px;
                margin-left: 230px * @scaleRate;
                img {
                    width: 100px * @scaleRate;
                    height: 44px * @scaleRate;
                }
            }
        }
    }
    .status {
        font-size: 15px;
        color: #111111;
        font-weight: bold;
        padding: 64px * @scaleRate 0 32px * @scaleRate;
        background-color: rgb(244,245,246);
    }
    main {
        width: 79.2%;
        margin: 100px * @scaleRate auto 0;
        .tip {
            font-size: 12px;
            position: absolute;
            right: 20px;
            top: 5px;
        }
        .label {
            font-size: 15px;
            color: #111111;
            flex-shrink: 0;
            font-weight: bold;
            margin-right: 30px * @scaleRate;
        }
        .form-box {
            background-color: #fff;
            height: 738px * @scaleRate;
            // padding-top: 112px * @scaleRate;
        }
    }
    .next {
        margin-top: 168px * @scaleRate;
        display: flex;
        justify-content: center;
        .common-btn {
            width: 120px * @scaleRate;
            height: 40px * @scaleRate;
            background: #4B89F3;
            color: #fff;
            font-size: 12px;
        }
    }
    .img-upload-box {
        background-color: #C5DBFF;
        width: 200px * @scaleRate;
        height: 200px * @scaleRate;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 140px * @scaleRate;
        background-position: center;
        background-size: cover;
        img {
            width: 78px * @scaleRate;
        }
    }
    .toast {
        position: fixed;
        top: 100px;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1001;
        width: 100%;
        &-content {
            position: absolute;
            width: 400px;
            height: 60px;
            top: 50%;
            left: 50%;
            margin-left: -200px;
            margin-top: -40px;
            line-height: 60px;
            overflow: hidden;
            background: rgba(0, 0, 0, .5);
            border-radius: 4px;
            text-align: center;
            font-size: 30px;
            color: #000;
        }
    }
</style>
<style lang="less">
    @import "../common/style/variables";
    .form-photo {
        .ivu-upload-drag {
            overflow: visible;
        }
    }
    .ivu-upload-drag {
        border: none;
    }
    .ivu-upload-drag:hover {
        border: none;
    }
    .foo-item .ivu-form-item-content {
        height: 200px * @scaleRate !important;
    }
    .form-box {
        // overflow: hidden;
        .ivu-form-item-content {
            align-items: center;
            height: 60px * @scaleRate;
            // justify-content: space-between;
        }
        .ivu-input {
            padding: 0 20px * @scaleRate;
            border-radius: 3px;
            font-size: 15px;
        }
        .label {
            font-size: 15px;
            color: #111111;
            flex-shrink: 0;
            // width: 150px;
            font-weight: bold;
            margin-right: 30px;
        }
        .ivu-form-item-required .ivu-form-item-label:before{
            content: '' !important;
        }
        .ivu-form-item{
            margin-bottom: 80px * @scaleRate;
            position: relative;
            width: 750px * @scaleRate;
        }
        .code-form {
            .ivu-form-item-content {
                // display: inline-block;
            }
            .ivu-input {
                width: 270px * @scaleRate !important;
            }
        }
        .ivu-input-wrapper {
            width: 450px * @scaleRate;
            .ivu-input {
                width: 450px * @scaleRate;
            }
        }
    }
    .ivu-form-item-error-tip{
        left: 100px;
    }
</style>
<template>
    <div>
        <nav class="navbar">
            <div class="container container-header" :class="clientWidth <= 1440 ? 'minScreen' : ''">
                <div class="logo">
                    <img src="../common/image/logo.png" alt="logo">
                </div>
            </div>
        </nav>
        <main>
            <p class="status">审核成功</p>
            <div class="form-box">
                <Form ref="setNickNameForm" :model="form" :rules="rule">
                    <Form-Item class="foo-item" style="padding-top: 84px;">
                        <span class="label">上 传 头 像 :</span>
                        <Upload
                                :on-success="successUpload"
                                :show-upload-list="false"
                                type="drag"
                                :action="$fileUpload">
                           <div class="img-upload-box" v-if="form.photo === ''">
                                <img src="../common/image/photo_icon.png" alt="">
                            </div>
                            <div v-else class="img-upload-box" :style="{backgroundImage: `url(${form.photo})`}"></div>
                        </Upload>
                    </Form-Item>
                    <Form-Item prop="nickname">
                        <span class="label">设置用户名:</span>
                        <Input v-model="form.nickname" placeholder="请输入用户名"/>
                        <span class="tip">请输入1~10个字符</span>
                    </Form-Item>
                </Form>

                <div class="next">
                    <button @click="goNext" type="button" class="common-btn">进入</button>
                </div>
            </div>
        </main>

        <div v-show="toast.show" class="toast">
            <div class="toast-content">
                {{toast.text}}
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      const validateNickname = (rule, value, callback) => {
        console.log(value.trim().length)
        if (value.trim().length === 0) {
          return callback(new Error('用户名不能全部为空格'));
        }
        callback()
      }
      return {
        rule: {
          nickname: [
            {required: true, message: '请输入正确的用户名', max: 10, min: 1, trigger: 'blur'},
            {validator: validateNickname, max: 10, min: 1, trigger: 'blur'}
          ]
        },
        form: {
          nickname: '', //用户名
          photo: '' // 头像
        },
        toast: {
          show: false,
          text: '',
          timer: undefined
        }
      }
    },
    methods: {
      // 上传成功回调
      successUpload (response, file, fileList) {
        this.form.photo = response.url
      },
      // 显示提示
      showToast (text, time = 1000) {
        if (!text.trim()) {
          return
        }
        if (this.toast.timer) {
          clearTimeout(this.toast.timer)
        }
        this.toast.text = text
        this.toast.show = true
        this.toast.timer = setTimeout(() => {
          this.toast.show = false
        }, time)
      },
      // 获取用户信息
      getUserInfo () {
        this.$store.dispatch('getUserInfo').then((res) => {
          this.$router.push({
            path: '/'
          })
        }, (err) => {
          console.log('获取用户信息失败')
        })
      },
      // 点击提交
      goNext () {
        this.$refs['setNickNameForm'].validate((valid) => {
          if (valid) {
            if (this.form.photo === '') {
              this.showToast('请上传头像')
              return
            }
            let _param = {...{token: localStorage.token || ''}, ...this.form}
            this.$ajax.updateNicknameAndPhoto(_param).then(res => {
              if (res.code === '0') {
                this.showToast('提交成功')
                this.getUserInfo()
              } else {
                this.showToast(res.msg)
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/setNickName.vue